/*----------------------------------------
 Content URL replacement */
import framework from 'framework';
import sessionStorage from 'lib/session-storage';

function getUrlParameter(name) {
	var url = location.href;
	name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
	var regexS = '[\\?&]' + name + '=([^&#]*)';
	var regex = new RegExp( regexS );
	var results = regex.exec( url );
	return results == null ? null : results[1];
}

function getAllUrlParameters() {
	var ap = {};
	framework.global.location.search.substring(1).split('&').forEach(function(item) {
		var s = item.split('='),
			k = s[0],
			v = s[1] && decodeURIComponent(s[1]);
		(k in ap) ? ap[k].push(v) : ap[k] = [v]; // eslint-disable-line no-unused-expressions
	});
	return ap;
}

function getClubPath(clubLink) {
	// remove the html from the links
	if(clubLink.indexOf('.html')) {
		clubLink = clubLink.substring(0, clubLink.indexOf('.html'));
	}
	// strip off items after the club
	var link = clubLink.match(/(.*\/clubs\/[a-zA-Z0-9\-%_]*\/[a-zA-Z0-9\-%_]*)(\/[a-zA-Z0-9\/\-%_]*)/);
	link = (link) ? link[1] : clubLink;

	return link;
}

function postToUrl(path, params) {
	var form = document.createElement('form');

	//Move the submit function to another variable
	//so that it doesn't get overwritten.
	form.submitFunction = form.submit;
	form.setAttribute('method', 'POST');
	form.setAttribute('action', path);

	function addField(key, value) {
		var hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', params[key]);
		form.appendChild(hiddenField);
	}

	for(var key in params) {
		if(params.hasOwnProperty(key)) {
			if( params[key] instanceof Array ){
				for(var i = 0; i < params[key].length; i++){
					addField(key, params[key][i]);
				}
			}else{
				addField(key, params[key]);
			}
		}
	}

	document.body.appendChild(form);
	form.submitFunction(); //Call the renamed function.
}

function getClubSubPath(clubLink) {
	// remove the html from the links
	if(clubLink.indexOf('.html')) {
		clubLink = clubLink.substring(0, clubLink.indexOf('.html'));
	}
	// strip off items after the club
	var link = clubLink.match(/.*\/clubs\/([a-zA-Z0-9\-%_]*\/[a-zA-Z0-9\-%_]*)\/([a-zA-Z0-9\/\-%_]*)/);
	link = (link && link[2]) ? link[2] : null;

	return link;
}

function subPagePath(clubLink, currentClubLink, currentClubQueryString) {
	var clubPath = getClubPath(clubLink);
	var clubSubPath = getClubSubPath(currentClubLink);

	// compare the links to see if we are on a subpage of the club
	//content/lt/en_us/clubs/mn/chanhassen.html
	//content/lt/en_us/clubs/mn/woodbury/classes.html

	if(clubSubPath) {
		return clubPath + '/' + clubSubPath + '.html' + currentClubQueryString;
	}else if(currentClubLink.match(/.*\/clubs\/.*/)){
		return clubPath + '.html' + currentClubQueryString;
	}else{
		return clubPath + '.html'; // on global page do not change it
	}
}

function removeQueryStringParam(key, value, url) {
	if(!url) {
		url = framework.global.location.href;
	}
	var re = new RegExp('([?&])' + key + '=.*?(&|#|$)(.*)', 'gi'),
		hash;

	if(re.test(url)) {
		if(typeof value !== 'undefined' && value !== null) {
			return url.replace(re, '$1' + key + '=' + value + '$2$3');
		} else{
			hash = url.split('#');
			url = hash[0].replace(re, '$1$3').replace(/(&|\?)$/, '');
			if(typeof hash[1] !== 'undefined' && hash[1] !== null) {
				url += '#' + hash[1];
			}
			return url;
		}
	} else{
		if(typeof value !== 'undefined' && value !== null) {
			var separator = url.indexOf('?') !== -1 ? '&' : '?';
			hash = url.split('#');
			url = hash[0] + separator + key + '=' + value;
			if(typeof hash[1] !== 'undefined' && hash[1] !== null) {
				url += '#' + hash[1];
			}
			return url;
		} else{
			return url;
		}
	}
}

function removeLta(url) {
	if(!url) {
		url = window.location.href;
	}
	return url.replace(/\/lta/, '');
}

function appendQueryParam(params, href) {
	var url = href;
	if(!url) {
		url = framework.global.location.href;
	}
	var keys = params ? Object.keys(params) : [];

	if(params && keys.length) {
		Object.keys(params).forEach((key) => {
			if(url.indexOf('?') > 0) {
				url += '&';
			} else{
				url += '?';
			}
			url += key + '=' + params[key];
		});
	}
	return url;
}

// check if a URL contains specific parameters
function checkForParams(parameter){
	var hasParams = false;
	var urlParams = getAllUrlParameters();
	if(!_.isEmpty(urlParams)) {
		_.each(urlParams, (value, param)=> {
			if(hasParams === true) {
				return false;
			}else if(param.startsWith(parameter)){
				hasParams = true;
			}
		});
	}
	return hasParams;
}

// store specific parameter values to session storage
function storeParams(parameter, key){
	var params = getAllUrlParameters();
	var paramsObj = {};
	if(!_.isEmpty(params)) {
		_.each(params, (value, param)=> {
			if(param.startsWith(parameter)) {
				paramsObj[param] = value;
			}
		});
	}
	// set params object to session storage with supplied key
	if(!_.isEmpty(paramsObj)) {
		sessionStorage.set(key, paramsObj);
	}
}

function handleParams(filter, type, params, spcParamName, spcParamValue) {
	var paramString = params[0];
	var interro = params[1];
	if(paramString.length >= 2048){
		console.log('You have selected too many filters');
	} else{
		if(spcParamName !== '' && typeof spcParamName !== 'undefined') {
			_.forEach(filter, (f) => {
				if(!interro && spcParamValue === ''){
					paramString += '?';
					interro = true;
				} else if(!interro && spcParamValue !== '' && paramString.indexOf(spcParamName) < 0){
					paramString += '?' + spcParamName + '=' + spcParamValue + '&';
					interro = true;
				} else{
					paramString += '&';
				}
				paramString += type + '=' + f;
			});
		}else{
			_.forEach(filter, (f) => {
				if(!interro){
					paramString += '?';
					interro = true;
				}else{
					paramString += '&';
				}
				paramString += type + '=' + f;
			});
		}

		params[0] = paramString;
		params[1] = interro;
		return params;
	}
}

function queryStringParser(name) {
	name = name.replace(/[\[\]]/g, '\\$&');

	const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`, 'i');

	const results = regex.exec(window.location.href);

	if(!results || !results[2]) {
		return '';
	}

	return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

// Removes `ct` (Customer Token) portion of login resource, if present
function removeCtIfPresent(loginResource) {
	// In the case we need to deal with, loginResource is a string in the form:
	// 	"/login.html?resource=%2F[somePath]%3Fct%3D[someAuthToken]"
	// The `resource` query parameter contains a portion of a URL that includes a `ct` query parameter
	// So the 'ct' parameter is embedded in the value of the 'resource' parameter, which is also URL-like
	// The goal of this function is return the loginResource without the ct (if it had one)
	// It uses native JS APIs in hopes of being more robust (but unfortunately, wordy)
	
	try {
		// exit if we don't find 'resource' followed by 'ct' 
		if (!loginResource.match(/resource.*ct/)) return loginResource;

		// Step 1: build a URL for the whole string
		const url = new URL(loginResource, window.location.origin)
		if (!url.searchParams.has('resource')) return loginResource;
	
		const params = new URLSearchParams(url.searchParams);
	
		// Step 2: get the 'resource' parameter
		const resourceValue = params.get('resource')
		// `resourceValue` could be a string in the form '%2F[somePath]%3Fct%3D[someAuthToken]'
		// We'll construct it into a URL to remove the `ct` parameter
	
		// Step 3: since the resourceValue is also URL-like, build it into a URL
		const resourceUrl = new URL(resourceValue, window.location.origin)
	
		const resourceParams = new URLSearchParams(resourceUrl.searchParams)

		if (!resourceParams.get('ct')) return loginResource;

		// Step 4: delete the 'ct' parameter
		resourceParams.delete('ct')

		// Step 5: rebuild the 'resource' parameter (with missing 'ct' now)
		let newResourceValue = `${resourceUrl.pathname}`
		if (resourceParams.size) {
			newResourceValue += `?${resourceParams}` // make sure to add in any other parameters that were there
		}
		params.set('resource', newResourceValue)

		return `${url.pathname}?${params}`
	
	} catch (error) {
		console.error('Error removing ct parameter', error)
		return loginResource
	}
}

var returnVal = {
	getUrlParameter: getUrlParameter,
	getAllUrlParameters: getAllUrlParameters,
	getClubPath: getClubPath,
	getClubSubPath: getClubSubPath,
	subPagePath: subPagePath,
	removeQueryStringParam: removeQueryStringParam,
	removeLta: removeLta,
	postToUrl: postToUrl,
	appendQueryParam: appendQueryParam,
	checkForParams: checkForParams,
	storeParams: storeParams,
	handleParams: handleParams,
	queryStringParser: queryStringParser,
	removeCtIfPresent: removeCtIfPresent
};

export default returnVal;

if(!String.prototype.startsWith) {
	String.prototype.startsWith = function(searchString, position) { // eslint-disable-line no-extend-native
		var lposition = position || 0;
		return this.indexOf(searchString, lposition) === lposition;
	};
}
